module.exports = __webpack_public_path__ + "assets/img/官方微博-e5ce2bae.png";